import { Fragment } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { tokenExists, updateDestination } from 'slices/auth'
import { useAppDispatch, useAppSelector } from 'store/hooks'

interface Props {
}

export function PrivateRoute(props: Props) {
    const isAuthenticated = useAppSelector(tokenExists)
    const to = useLocation()
    const dispatch = useAppDispatch()

    if (isAuthenticated) {
        dispatch(updateDestination(''))
    }

    const destination = () => {

        dispatch(updateDestination(to.pathname))

        return '/login'
    }



    return <Fragment>
        {isAuthenticated ? <Outlet /> : <Navigate to={destination()} />}
    </Fragment>
}
